export default __webpack_public_path__ + "static/media/tracks-bottom.e471bbda.svg";